import React from 'react'
import { Link } from 'react-router-dom'

import { footerSocial } from '../data'

export default function FooterLightSmall() {
  return (
    <footer className="footer bg-white border-top footer-bar">
            <div className="container text-center">
                <div className="row align-items-center">
                    <div className="col-sm-6">
                        <div className="text-sm-start">
                            <p className="mb-0">© {new Date().getFullYear()} <span className="text-reset">Leaping</span>. Design & Develop with <i className="mdi mdi-heart text-danger"></i> by <Link to="https://shreethemes.in" target="_blank" className="text-reset">Shreethemes-studio</Link>.</p>
                        </div>
                    </div>

                    <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <ul className="list-unstyled text-sm-end social-icon mb-0">
                            {footerSocial.map((item,index)=>{
                                let Icon = item.icon
                                return(
                                    <li className="list-inline-item m-x-2" key={index}><Link to={item.link} target="_blank" className="rounded"><i className="align-middle" title="Buy Now"><Icon/></i></Link></li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
  )
}
